import {
  IMarketingCampaignStep,
  MarketingCampaignStepStatus,
} from '@principle-theorem/principle-core/interfaces';
import { AtLeast, uid } from '@principle-theorem/shared';

export class MarketingCampaignStep {
  static init(
    overrides: AtLeast<IMarketingCampaignStep, 'config'>
  ): IMarketingCampaignStep {
    return {
      uid: uid(),
      name: '',
      status: MarketingCampaignStepStatus.Draft,
      metadata: {
        conversions: 0,
        unsubscribes: 0,
      },
      deleted: false,
      ...overrides,
    };
  }

  static duplicate(step: IMarketingCampaignStep): IMarketingCampaignStep {
    return MarketingCampaignStep.init({
      name: `${step.name} copy`,
      config: step.config,
      status: MarketingCampaignStepStatus.Draft,
    });
  }

  static isActive(step: IMarketingCampaignStep): boolean {
    return step.status === MarketingCampaignStepStatus.Active;
  }
}
